import { admin } from "./axios";
import {
  IOutfitDetailsPostCountResult,
  OutfitDetailsPostCountApiResponse,
} from "../../interface/OutfitDetailsPostCountInterface";

export type OutfitPostCountGender = "Men" | "Women";
export type OutfitPostCountCategory = "Ethnic" | "Western";

export interface GetOutfitDetailsPostCountParams {
  startDate: string;
  endDate: string;
  genders: OutfitPostCountGender[];
  categories: OutfitPostCountCategory[];
  carousel: boolean;
}

export const getOutfitDetailsPostCount = async (
  params: GetOutfitDetailsPostCountParams
): Promise<IOutfitDetailsPostCountResult> => {
  const searchParams = new URLSearchParams();
  searchParams.append("startDate", params.startDate);
  searchParams.append("endDate", params.endDate);
  params.genders.forEach(gender => searchParams.append("gender", gender));
  params.categories.forEach(category =>
    searchParams.append("category", category)
  );
  searchParams.append("carousel", String(params.carousel));

  const response = await admin.get<OutfitDetailsPostCountApiResponse>(
    `outfit-details/post-count?${searchParams.toString()}`
  );

  return response.data.data;
};
